import { ReactNode } from 'react';
import {
  FloatingAxesOffsets,
  FloatingPosition,
  Menu as MantineMenu,
} from '@mantine/core';

import styles from './menu.module.scss';

export type MenuProps = {
  menuDropdown: ReactNode;
  menuTarget: ReactNode;
  offset?: number | FloatingAxesOffsets;
  onChange?: (opened: boolean) => void;
  opened?: boolean;
  position?: FloatingPosition;
  trigger?: 'hover' | 'click';
  usePortal?: boolean;
  width?: number;
};

export function Menu({
  menuDropdown,
  menuTarget,
  offset,
  onChange,
  opened,
  position = 'bottom-start',
  trigger = 'click',
  usePortal,
  width,
}: MenuProps) {
  return (
    <div className={styles['root']}>
      <MantineMenu
        classNames={{
          dropdown: styles['dropdown'],
          item: styles['item'],
          itemLabel: styles['itemLabel'],
        }}
        data-testid="navigation-header-user-icon"
        onChange={onChange}
        opened={opened}
        transitionProps={{ duration: 0 }}
        trigger={trigger}
        offset={offset}
        position={position}
        unstyled
        width={width}
        withinPortal={usePortal}
      >
        <MantineMenu.Target>{menuTarget}</MantineMenu.Target>
        <MantineMenu.Dropdown>{menuDropdown}</MantineMenu.Dropdown>
      </MantineMenu>
    </div>
  );
}
